module.exports = __webpack_public_path__ + "static/img/harrow-tine.6ab9bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/showcase/harrow-tine.png
// module id = VU9w
// module chunks = 1